import useSWR from "swr";

export const useFetchAveragePrice = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `ifrea_analytics/restaurants/${restaurantId}/average-price/` : null;
  const { data: averagePrice, isLoading } = useSWR<number>(fetcherKey)
  return { averagePrice, isLoading };
};